import React from "react";
import styled from "styled-components";
import { defineMessages, useIntl } from "react-intl";
import { internalPath } from "tr-web";
import { Breadcrumbs } from "../../../shared/components/Breadcrumbs";
import { WideContainer } from "../../../shared/components/WideContainer";

const messages = defineMessages({
  home: {
    id: "TaskTemplateServiceBreadcrumbs.home",
    defaultMessage: "Home",
  },
  services: {
    id: "TaskTemplateServiceBreadcrumbs.services",
    defaultMessage: "Services",
  },
});

export interface TaskTemplateServiceBreadcrumbsProps {
  marketingGroupIndexPath: string;
  marketingGroupTitle: string;
  origin: string;
  path: string;
  serviceIndexPath: string;
  templateName: string;
}

export function TaskTemplateServiceBreadcrumbs({
  marketingGroupIndexPath,
  marketingGroupTitle,
  origin,
  path,
  serviceIndexPath,
  templateName,
}: TaskTemplateServiceBreadcrumbsProps) {
  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage(messages.home),
      href: internalPath("/"),
    },
    {
      title: intl.formatMessage(messages.services),
      href: internalPath(serviceIndexPath),
    },
  ];

  if (marketingGroupTitle && marketingGroupIndexPath) {
    breadcrumbs.push({
      title: marketingGroupTitle,
      href: internalPath(marketingGroupIndexPath),
    });
  }

  if (path && templateName) {
    breadcrumbs.push({
      title: templateName,
      href: internalPath(path),
    });
  }

  return (
    <HideOnMobile>
      <VerticalPadding>
        <WideContainer>
          <CenterWhenSmall>
            <Breadcrumbs breadcrumbs={breadcrumbs} origin={origin} />
          </CenterWhenSmall>
        </WideContainer>
      </VerticalPadding>
    </HideOnMobile>
  );
}
const HideOnMobile = styled.div`
  display: none;
  max-width: 1200px;
  margin: 1rem auto 0 auto;

  ${(props) => props.theme.breakpoints.tabletUp} {
    display: block;
  }
`;

const VerticalPadding = styled.div`
  /* padding-top: ${(props) => props.theme.spacing.lg};
  padding-bottom: ${(props) => props.theme.spacing.lg}; */
`;

const CenterWhenSmall = styled.div`
  @media (max-width: 800px) {
    text-align: center;
  }
`;
